import React from 'react';
import { BoxSelection, BoxSelectionOptionProps } from 'wix-ui-tpa/cssVars';
import Text from '../../../Components/Text';
import { classes } from '../TipAmountSelector.st.css';
import { Preset, PresetType } from '../../../../../types';
import { TFunction } from '@wix/yoshi-flow-editor';
import { TipAmountSelectorDatahooks } from '../../../datahooks';
import Loader from './Loader';

export type PresetArgs = {
  preset: Preset;
};

const getDeafultBoxSelectionOptionProps = ({
  preset,
}: PresetArgs): BoxSelectionOptionProps & {
  key: string;
} => ({
  id: preset.id,
  key: preset.id,
  checked: preset.isSelected,
});

const renderBoxSelectionOption = ({ preset }: PresetArgs) => (
  <BoxSelection.Option
    {...getDeafultBoxSelectionOptionProps({ preset })}
    aria-label={preset.formattedValue}
  >
    <Loader preset={preset}>
      <Text
        className={classes.boxSelectionOptionText}
        data-hook={`${TipAmountSelectorDatahooks.BOX_SELECTION_OPTION}-${preset.id}`}
      >
        {preset.formattedValue}
      </Text>
    </Loader>
  </BoxSelection.Option>
);

const rendeCustomBoxSelectionOption = ({
  preset,
  t,
}: PresetArgs & { t: TFunction }) => (
  <BoxSelection.Option
    {...getDeafultBoxSelectionOptionProps({ preset })}
    aria-label={t('app.wix-tips.widget.custom-amount-button.text')}
    className={classes.customAmount}
  >
    <Text
      className={classes.boxSelectionOptionText}
      data-hook={`${TipAmountSelectorDatahooks.BOX_SELECTION_OPTION_CUSTOM}-${preset.id}`}
    >
      {t('app.wix-tips.widget.custom-amount-button.text')}
    </Text>
  </BoxSelection.Option>
);

export const renderPreset = ({ preset, t }: PresetArgs & { t: TFunction }) => {
  if (preset.type === PresetType.Custom) {
    return rendeCustomBoxSelectionOption({ preset, t });
  }
  return renderBoxSelectionOption({ preset });
};
